import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: { title: 'Home - IDWS 2026' }
  },
  {
    path: '/agenda',
    name: 'agenda',
    component: () => import('../views/AgendaView.vue'),
    meta: { title: 'Agenda - IDWS 2026' }
  },
  {
    path: '/speakers',
    name: 'speakers',
    component: () => import('../components/SpeakersSection.vue'),
    meta: { title: 'Speakers - IDWS 2026' }
  },
  {
    path: '/exhibition',
    name: 'exhibition',
    component: () => import('../views/ExhibitionView.vue'),
    meta: { title: 'Exhibition - IDWS 2026' }
  },
  {
    path: '/journey',
    name: 'journey',
    component: () => import('../views/JourneyView.vue'),
    meta: { title: 'Journey - IDWS 2026' }
  },
  {
    path: '/registration',
    name: 'registration',
    component: () => import('../views/RegistrationView.vue'),
    meta: { title: 'Registration - IDWS 2026' }
  },
  {
    path: '/mobile-registration',
    name: 'mobile-registration',
    component: () => import('../views/MobileRegistrationView.vue'),
    meta: { title: 'Quick Registration - IDWS 2026' }
  },
  {
    path: '/events/idws-2025',
    name: 'idws-2025',
    component: () => import('../views/Events/IDWS2025View.vue'),
    meta: { title: 'IDWS 2025 - International Digital Workplace Summit' }
  },
  {
    path: '/events/idws-2026',
    name: 'idws-2026',
    component: () => import('../views/Events/IDWS2026View.vue'),
    meta: { title: 'IDWS 2026 - International Digital Workplace Summit' }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('../views/NotFoundView.vue'),
    meta: { title: '404 - Page Not Found | IDWS' }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

// Navigation guards
router.beforeEach((to, from, next) => {
  // Update page title
  document.title = to.meta.title || 'International Digital Workplace Summit (IDWS) 2026'
  next()
})

export default router
